// extracted by mini-css-extract-plugin
export default {"support":"support__CXL5s","supportBtn":"supportBtn__hrVKJ","logo":"logo__gGbIo","supportEmail":"supportEmail__PYQMX"};